import { Notification } from '../../model/Notification'
import { Action } from 'typesafe-actions'

export type NotificationState = {
  Notifications: { [k: string]: Notification }
}

export enum NotificationActionsTypes {
  ADD_NOTIFICATION = 'notification/add_notification',
  CLEAR_NOTIFICATION = 'notification/clear_notification',
}

interface AddNotification extends Action {
  type: NotificationActionsTypes.ADD_NOTIFICATION
  key: string
  notification: Notification
}

interface ClearNotifications extends Action {
  type: NotificationActionsTypes.CLEAR_NOTIFICATION
}

export type NotificationActions = AddNotification | ClearNotifications
